// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3UJsZ","header":"Messages_header__1HnCs"};